import { IApplicationState } from '../../../../../types/types';
import { getCookieScopesFromUser } from './getCookieScopesFromUser';

export const isShowCookieDialogForUser = (state: IApplicationState) => {
    return getCookieScopesFromUser(state) === undefined
};
